import Model from './model'

class User extends Model {

  constructor(params) {
    super()

    this.id = params.id
    this.name = params.name
    this.email = params.email
    this.avatar_url = params.avatar_url
    this.token = params.token
    this.permission = params.permission
  }

  //
  // Permissions
  //

  static get permissions() {
    return {
      1: '建立專案',
      2: '編輯專案',
      4: '預覽專案',
      8: '刪除專案',
      16: '發佈',   // publish
      32: '發佈核准' // review
    }
  }

  /**
   * Get permission code
   * @param  {Number} permissions
   * @return {Array}
   */
  get permissions() {
    return Object.keys(User.permissions).filter(bit => (this.permission & bit) !== 0)
  }

  get canCreateProject() {
    return this.permissions.includes('1')
  }

  get canEditProject() {
    return this.permissions.includes('2')
  }

  get canPreviewProject() {
    return this.permissions.includes('4')
  }

  get canDeleteProject() {
    return this.permissions.includes('8')
  }

  get canPublishProject() {
    return this.permissions.includes('16')
  }

  get canReviewProject() {
    return this.permissions.includes('32')
  }

  //
  // Auth
  //

  static loginWithGoogle(code, redirectURI) {
    return this.http.post('auth/google/callback', { code, redirect_uri: redirectURI })
      .then(res => res.data)
  }

  static loginWithToken(token) {
    return this.http.post('auth', { token })
      .then(res => res.data)
  }

}

export default User



// WEBPACK FOOTER //
// ./src/models/user.js